/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Documents_To_RequestInputs */

const en_select_documents_to_request = /** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select documents to request access from the seller.`)
};

const id_select_documents_to_request = /** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih dokumen untuk meminta akses dari penjual.`)
};

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const es_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const fr_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const de_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const ja_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const zh_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const ar_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const it_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const ru_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const pt_select_documents_to_request = en_select_documents_to_request;

/** @type {(inputs: Select_Documents_To_RequestInputs) => LocalizedString} */
const ko_select_documents_to_request = en_select_documents_to_request;

/**
* | output |
* | --- |
* | "Select documents to request access from the seller." |
*
* @param {Select_Documents_To_RequestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const select_documents_to_request = /** @type {((inputs?: Select_Documents_To_RequestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Documents_To_RequestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_documents_to_request(inputs)
	if (locale === "es") return es_select_documents_to_request(inputs)
	if (locale === "fr") return fr_select_documents_to_request(inputs)
	if (locale === "de") return de_select_documents_to_request(inputs)
	if (locale === "ja") return ja_select_documents_to_request(inputs)
	if (locale === "zh") return zh_select_documents_to_request(inputs)
	if (locale === "ar") return ar_select_documents_to_request(inputs)
	if (locale === "id") return id_select_documents_to_request(inputs)
	if (locale === "it") return it_select_documents_to_request(inputs)
	if (locale === "ru") return ru_select_documents_to_request(inputs)
	if (locale === "pt") return pt_select_documents_to_request(inputs)
	return ko_select_documents_to_request(inputs)
});